import { Component } from '@angular/core';
import { IpoTranslatePipe } from '@ip-only/front-end-library';
import { DeliveryOverviewService } from '../../service/delivery-overview.service';

@Component({
  selector: 'app-delivery-overview-search',
  templateUrl: './delivery-overview-search.component.html',
  styleUrls: ['./delivery-overview-search.component.scss'],
  providers: [IpoTranslatePipe],
  standalone: false,
})
export class DeliveryOverviewSearchComponent {
  constructor(
    private deliveryOverviewService: DeliveryOverviewService,
    private translate: IpoTranslatePipe,
  ) {}

  handleSearch(filter: string) {
    this.deliveryOverviewService.setFilterString(filter);
  }
}
